package services.http

import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.project.previews.ProjectQueryComponent
import it.neckar.lizergy.model.project.previews.ProjectQueryForUser
import it.neckar.lizergy.model.project.previews.ResolvedProjectPreview
import it.neckar.lizergy.model.project.process.state.LizergyProcessStates
import it.neckar.rest.RestResponse
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProjectQueryRequest(
  val processStatesToFilter: List<@Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates>,
  val processStatesToHide: List<@Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates>,
  val filteredByCompanyCode: CompanyCode?,
  val filteredByMaintainer: UserLoginName?,
  val filteredByEditor: UserLoginName?,
  val filterValueProject: String?,
  val filterValueAddress: String?,
  val filterByProjectState: @Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates?,
  val onlyRestarbeiten: Boolean,
  val onlyEigenmontage: Boolean,
  val onlyDachmontage: Boolean,
  val onlyElektroinstallation: Boolean,
  val indexOfFirstVisibleProject: Int,
  val indexOfLastVisibleProject: Int,
  val sorting: ProjectQuerySorting,
  val projectQueryComponent: ProjectQueryComponent?,
  val includeArchived: Boolean,
)

@Serializable
enum class ProjectQuerySortedBy {
  Unsorted,
  SortedAscending,
  SortedDescending,
}

@Serializable
enum class ProjectQuerySortedColumn {
  ProjectColumn,
  ComponentDetails,
  Maintainer,
  CustomerColumn,
  EditorColumn,
  ProcessStateColumn,
  ProcessStatesColumn,
  ProcessStatesDatesColumn,
  AccountingTable,
}

@Serializable
data class ProjectQuerySorting(
  val sortedBy: ProjectQuerySortedBy,
  val sortedColumn: ProjectQuerySortedColumn,
  val projectQueryForUser: ProjectQueryForUser,
  val loggedInUser: UserLoginName,
)


@Serializable
sealed interface ProjectQueryResponse : RestResponse<ProjectQueryData> {

  @Serializable
  @SerialName("good")
  data class Good(override val data: ProjectQueryData) : ProjectQueryResponse, RestResponse.GoodResponse<ProjectQueryData>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : ProjectQueryResponse, RestResponse.BadResponse<ProjectQueryData>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: ProjectQueryData): ProjectQueryResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): ProjectQueryResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: ProjectQueryData?): ProjectQueryResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}

@Serializable
data class ProjectQueryData(
  val visibleProjectPreviews: List<ResolvedProjectPreview>,
  val numberOfTotalFilteredProjects: Int,
  val numberOfTotalRelevantProjects: Int,
)
